import { assertNever } from '@dadohr/shared/domainTypes/00-assertNever';
import {
  isContentTemplateBlock,
  isLayoutTemplateBlock,
  isSubTaskTemplateBlock,
  SubTaskStatus,
  TaskBlockDenormalized,
  TaskBlockTemplate
} from '@dadohr/shared/domainTypes/experience';
import { IOrganization } from '@dadohr/shared/domainTypes/org';
import {
  toDenormalizedContentBlock,
  toDenormalizedLayoutBlock,
  toDenormalizedSubTask
} from '../../../../../../services/experiences/instance';
import {
  ExperienceReplacements,
  InterpolationDefaultOptions
} from '../../../../../../services/set/interpolation';
import { now } from '../../../../../../services/time';

export const denormalizeBlocksForPreview = (
  blocks: TaskBlockTemplate[],
  org: IOrganization,
  tz: string
) => {
  // create all subtask states
  const replacements: ExperienceReplacements = {
    experience: { vars: { title: '', tasks: {} } },
    org: { vars: { name: org.name } },
    roles: []
  };
  const interpolationOptions: InterpolationDefaultOptions = {
    dateFormat: org.dateFormats.MMDDYYYY
  };
  const n = now();
  return blocks.map<TaskBlockDenormalized>((b) => {
    if (isSubTaskTemplateBlock(b)) {
      return toDenormalizedSubTask(
        {
          id: b.id,
          templateId: b.id,
          type: b.type,
          status: SubTaskStatus.OPEN,
          completedAt: null,
          requirementType: b.requirementType,
          parentLayoutElement: b.parentLayoutElement || null
        },
        b,
        replacements,
        { answersById: {}, calendlyEventsById: {} },
        interpolationOptions,
        tz,
        n,
        n,
        [],
        {}
      );
    }
    if (isContentTemplateBlock(b)) {
      return toDenormalizedContentBlock(b, replacements, interpolationOptions);
    }

    if (isLayoutTemplateBlock(b)) {
      return toDenormalizedLayoutBlock(b);
    }

    return assertNever(b);
  });
};
